module.exports = __webpack_public_path__ + "static/fonts/NotoSansCJKkr-Black.72b1dab.woff";